<template>
	<div class="import-wrapper">
		<el-tabs type="card" class="import-nav">
			<el-tab-pane>
				<span slot="label" :class="['import-tab', { error: unconfirmedCount > 0}]">
					<h5>{{ unconfirmedCount }}</h5>
					<span class="tabPaneHeading">Unresolved Events</span>
				</span>

				<template
					v-if="unconfirmedPatient.length > 0">
					<PatientEvent v-for="(importPatient, index) in unconfirmedPatient"
						:patient="importPatient"
						:key="index"
						:index="index + 1"
						:column="column">
					</PatientEvent>
				</template>
				<p v-else
					class="noPatients">
					No event in this category
				</p>

			</el-tab-pane>
			<el-tab-pane>
				<span slot="label" :class="['import-tab', { error: reschedulePatient.length > 0}]">
					<h5>{{ reschedulePatient.length }}</h5>
					<span class="tabPaneHeading">Rescheduled Events</span>
				</span>
				
				<template
					v-if="reschedulePatient.length > 0">
					<PatientReschedule v-for="(importPatient, index) in reschedulePatient"
						:patient="importPatient"
						:column="column"
						:key="index"
						:index="index + 1"
						:confirm="true">
					</PatientReschedule>
				</template>
				<p v-else
					class="noPatients">
					No event in this category
				</p>

			</el-tab-pane>
			<el-tab-pane>
				<span slot="label" class="import-tab">
					<h5>{{ confirmedEvents }}</h5>
					<span class="tabPaneHeading">Scheduled Events</span>
				</span>

				<PatientRows 
					v-if="confirmedPatient.length > 0"
					:patients="confirmedPatient"
					:column="column"
					row-component-type="PatientEvent">
				</PatientRows>
				<p v-else
					class="noPatients">
					No event in this category
				</p>

			</el-tab-pane>
			<el-tab-pane>
				<span slot="label" class="import-tab">
					<h5>{{ sameSchedulePatient.length }}</h5>
					<span class="tabPaneHeading">Already Scheduled Events</span>
				</span>

				<PatientRows
					v-if="sameSchedulePatient.length > 0"
					:patients="sameSchedulePatient"
					:column="column"
					:same-schedule="true"
					row-component-type="PatientEvent">
				</PatientRows>
				<p v-else
					class="noPatients">
					No event in this category
				</p>

			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import ImportTable from '.'

export default {
	name: 'select-event-import-table',
	extends: ImportTable,

	data() {
		return {
			showConfirmedPatients: false,
			showSameSchedulePatients: false,
			showReschedulePatients: false,
		}
	},

	mounted() {
		this.$emit('totalEventCount', this.totalEventCount)
	},
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>

<style scoped>
.import-wrapper >>> .el-tabs__header {
	background-color: #f8f8f8;
}
.import-wrapper >>> .el-tabs__item.is-active {
	background-color: #ffffff;
	border: 1px solid #e4e7ed !important;
	border-bottom: 1px solid #e4e7ed !important;
	top: 2px;
}
.import-wrapper >>> .el-tabs__nav {
	border: none !important;
}
.import-wrapper >>> .el-tabs__item {
	border: none !important;
}
.noPatients {
	color: #666666;
	font-size: 16px;
	padding: 20px 2px;
}

/* fix tab width */
.import-wrapper >>> #tab-0 {
	min-width: 218px
}
.import-wrapper >>> #tab-1 {
	min-width: 228px
}
.import-wrapper >>> #tab-2 {
	min-width: 213px
}
.import-wrapper >>> #tab-3 {
	min-width: 268px
}
</style>
